export const ROUTES = {
	auth: '/auth',

	myClients: '/my-clients',
	myClient: '/my-client/',

	profile: '/profile',
	builder: '/builder',

	clients: '/clients',
	client: '/client/',

	admin: '/admin',
	adminUsers: '/admin/users',
	adminUser: '/admin/users/',
	adminStats: '/admin/stats',
	adminSettings: '/admin/settings',
} as const;
